module.exports = __webpack_public_path__ + "img/amp.dd852996.svg";